import React from 'react';
import HomeRoutes from 'src/navigation/HomeRoutes';

const Home = (): React.ReactElement => {
  return <HomeRoutes />;
};

export default Home;
